import EventEmitter from './EventEmitter.js'
import Experience from '../../Experience.js'

import * as THREE from 'three'

export default class Input extends EventEmitter {
    constructor()
    {
        // Construct Base Class
        super()

        // Setup
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.debugActive = this.experience.debug.active
        this.time = this.experience.time

        // Poll Events
        this.lastMove = Date.now()

        this.cursor = new THREE.Vector2()
        this.mouse  = new THREE.Vector2(-1, 1)

        // Events
        window.addEventListener('pointermove', (event) => this.onMouseMove(event))
        window.addEventListener('pointerdown', (event) => this.onMouseDown(event))
        window.addEventListener('pointerup', (event) => this.onMouseUp(event))
        // window.addEventListener('dragover', (event) => this.onMouseMove(event))
        window.addEventListener('pointercancel', (event) => this.onPointerCancel(event))

        this.time.on('visible', () => this.onVisible())
        
    }

    // Callback Methods
    onMouseMove(event)
    {
        // if(Date.now() - this.lastMove < 15)
        // {
        //     return
        // }
        // else {
        //     this.lastMove = Date.now()
        // }
        this.cursor.x = (event.clientX / this.sizes.width) - 0.5
        this.cursor.y = -(event.clientY / this.sizes.height) + 0.5

        this.mouse.x = event.clientX / this.sizes.width * 2 - 1
        this.mouse.y = - (event.clientY / this.sizes.height * 2 - 1)

        this.trigger('move')

        // Debug Only
        if(this.debugActive)
        {
            const dot =  document.getElementById(event.pointerId)
            if(dot === null) return
            this.animateDot(event, dot)
        }
        
    }

    onMouseDown(event)
    {
        this.mouse.x = event.clientX / this.sizes.width * 2 - 1
        this.mouse.y = - (event.clientY / this.sizes.height * 2 - 1)

        if(event.button === 0)
        {
            this.trigger('press')
        }

        // Debug Only
        if(this.debugActive)
        {
            const dot = document.createElement("div")
            dot.classList.add("dot")
            dot.id = event.pointerId
            this.animateDot(event, dot)
            document.body.append(dot)
        }
    }

    onMouseUp(event)
    {
        if(event.button === 0)
        {
            this.trigger('release')
        }

        // Debug Only
        if(this.debugActive)
        {
            const dot =  document.getElementById(event.pointerId)
            if(dot === null) return
            dot.remove()
        }

        this.mouse.x = 0 / this.sizes.width * 2 - 1
        this.mouse.y = - (0 / this.sizes.height * 2 - 1)
    }

    onPointerCancel(event)
    {
        this.trigger('release')
        if(this.debugActive)
        {
            const dot =  document.getElementById(event.pointerId)
            if(dot === null) return
            dot.remove()
        }
    }

    onVisible()
    {
        this.mouse.x = 0 / this.sizes.width * 2 - 1
        this.mouse.y = - (0 / this.sizes.height * 2 - 1)
    }

    // Debug Only
    animateDot(e, object)
    {
        object.style.width = `${e.width / Math.min(window.devicePixelRatio, 2)}px`
        object.style.height = `${e.height / Math.min(window.devicePixelRatio, 2)}px`
        object.style.left = `${e.pageX}px`
        object.style.top = `${e.pageY}px`
    }
}